module.exports = __webpack_public_path__ + "static/media/ill1.accf757d.svg";